module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true,
      "autoFocusField": false
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Opret klasse på tur")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Vælg klasser")]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.klassCalendars,
      "itemsSelected": _vm.selectedKlasses,
      "multiple": true,
      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars'),
      "showCalendarYear": true
    },
    on: {
      "update": _vm.setSelectedKlasses
    }
  })], 1), _vm._v(" "), (_vm.selectedKlasses.length > 0) ? [_c('ClassOnTripSubject', {
    attrs: {
      "schoolId": _vm.schoolId,
      "calendarId": _vm.selectedKlasses[0]['id'],
      "date": _vm.date,
      "selectedSubject": _vm.selectedSubject
    },
    on: {
      "setSubject": _vm.setSelectedSubject
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Personale")]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.userCalendars,
      "itemsSelected": _vm.selectedUsers,
      "multiple": true,
      "placeholder": _vm.$t('vue2.dselect.placeholder_calendars')
    },
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.date
    },
    on: {
      "changed": _vm.setDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Tid")]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__padding",
    staticStyle: {
      "padding": "1rem 3rem"
    }
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.isValidated) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit do-bttn--submit--disabled"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.create')) + "\n      ")]) : _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.create')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e69a1cb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/ClassOnTrip/ClassOnTrip.vue
// module id = 2150
// module chunks = 1